import { useWindowSize } from "@react-hookz/web";
import { useState } from "react";
import { Button, Drawer, Icon, Loading, Modal, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { useGetBankAccountQuery } from "@/redux/apis/bankAccount/bankAccountApi";
import { BankDetailsEdit } from "../contents/BankDetailsEdit";
import { BankDetailsView } from "../contents/BankDetailsView";
import { usePayoutHistoryContext } from "../context";
import { BankDetailsStep } from "../types";

interface BankDetailsModalProps {
  open: boolean;
  onClose: () => void;
}

export const BankDetailsModal = ({ open, onClose }: BankDetailsModalProps) => {
  const { width } = useWindowSize();

  return (
    <>
      {width >= 768 ? (
        <Modal open={open} onClose={onClose} className="w-[550px] !px-5 !py-8">
          <Content onClose={onClose} />
        </Modal>
      ) : (
        <Drawer open={open} onOpenChange={(open) => !open && onClose()}>
          <></>
          <Content onClose={onClose} />
        </Drawer>
      )}
    </>
  );
};

const Content = ({ onClose }: { onClose: () => void }) => {
  const { driver } = usePayoutHistoryContext();
  const { country } = useOperator();
  const { data, isFetching } = useGetBankAccountQuery(driver.uuid);
  const [step, setStep] = useState<BankDetailsStep>();
  const bankAccount = data?.data;
  const isStripeManaged = bankAccount?.type === "stripe_managed";

  return (
    <div className="relative mt-3 w-full sm:mt-0 sm:text-left">
      {isFetching && <Loading />}
      <div className="flex flex-row items-center">
        <Typography variant="title" className="flex-1">
          {`${driver.personal.firstName} ${driver.personal.lastName} Bank Details`}
        </Typography>
        <Icon name="close" isCustom className="flex cursor-pointer justify-end" onClick={onClose} />
      </div>
      {isStripeManaged || country !== "AU" ? (
        <div className="mt-3 flex flex-col gap-4 rounded-lg border border-neutral-mid-gray bg-neutral-surface-gray p-5">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Bank details for this driver are managed via Stripe. The driver can update their bank details through the Stripe
            onboarding process.
          </Typography>
          <Button variant="secondary" size="sm" className="w-full sm:w-fit" onClick={onClose}>
            Close
          </Button>
        </div>
      ) : step === "edit" ? (
        <BankDetailsEdit setStep={setStep} bankAccount={bankAccount} />
      ) : (
        <BankDetailsView setStep={setStep} bankAccount={bankAccount} />
      )}
    </div>
  );
};
